import { Component } from '@angular/core';
import { EnumStatusCode } from 'src/app/enum/enumStatusCode';
import { Articledata, ResponseArticle } from 'src/app/shared/models/article';
import { news } from 'src/app/shared/models/home';
import { AritcleService } from 'src/app/shared/services/article.service';
import { BaseService } from 'src/app/shared/services/base.service';
import { HomeService } from 'src/app/shared/services/home.service';

@Component({
  selector: 'app-news-list',
  templateUrl: './news-list.component.html',
  styleUrls: ['./news-list.component.scss']
})

export class NewsListComponent {
  searchOpen = true;
  newsres = new ResponseArticle;
  newslist: Articledata = {} as Articledata;
  TotalItems=0;
  constructor(
    public homeService: HomeService,
    // private router: Router,
    public baseService: BaseService,
    public aritcleService: AritcleService
  ) {
    this.newsres.FunctionID = 7101;
  }

  // Getnews() {
  //   this.newsres.FunctionID = 7101;
  //   this.aritcleService.GetArticleByUnit(this.newsres).subscribe((res) => {
  //     if (res.StatusCode == EnumStatusCode.Success) {
  //       this.newslist = res.Entries;
  //       this.TotalItems= res.TotalItems;
  //       console.log(this.newslist.Data)
  //     }
  //   });
  // }

  // onChildClicked() {
  //   this.newsres.PageSize=this.newsres.PageSize + 10;
  //   this.Getnews()
  // }
}
